var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.213 18.227l-6.081-6.082 6.081-6.081c0.143-0.129 0.232-0.314 0.232-0.521 0-0.387-0.313-0.7-0.7-0.7-0.201 0-0.382 0.085-0.51 0.22l-0 0-0.012 0.011-6.081 6.082-6.081-6.082c-0.126-0.122-0.297-0.196-0.486-0.196-0.387 0-0.7 0.313-0.7 0.7 0 0.184 0.071 0.351 0.187 0.476l-0-0 0.012 0.011 6.081 6.081-6.081 6.082c-0.127 0.127-0.205 0.302-0.205 0.495 0 0.387 0.313 0.7 0.7 0.7 0.193 0 0.368-0.078 0.495-0.205l6.081-6.082 6.081 6.082c0.127 0.127 0.302 0.205 0.495 0.205 0.387 0 0.7-0.313 0.7-0.7 0-0.193-0.078-0.368-0.205-0.495v0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close.1f289ab5.svg";
export { ForwardRef as ReactComponent };